// Taşeron portalı — ortak create / bağlantı yüzeylerinin bağı (GL6). Uçlar §4.2–§4.4 (SP): firma ve taşeron
// istekte YOKTUR (token/bağdan çözülür, §13.6). Anahtar `companyId` taşır.
import { type PersonnelActivationClient, supplierContractorApi } from '@isgportal/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { supplierContractorKeys } from './supplierContractorKeys';

export function usePersonnelActivationClient(companyId: number | null): PersonnelActivationClient {
  const queryClient = useQueryClient();
  return useMemo<PersonnelActivationClient>(
    () => ({
      create: (body) => supplierContractorApi.createSupplierPersonnel(body),
      sendLink: (userUuid, body) =>
        supplierContractorApi.sendSupplierActivationLink(userUuid, body),
      resend: (invitationUuid, body) =>
        supplierContractorApi.resendPersonnelInvite({ invitationUuid, ...body }),
      cancel: (invitationUuid) => supplierContractorApi.cancelSupplierInvitation(invitationUuid),
      // Aday listesi (izin ekle penceresi) AYNI anahtardır → tek tazeleme ikisini de kapsar.
      invalidate: () => {
        queryClient.invalidateQueries({ queryKey: supplierContractorKeys.personnel(companyId) });
      },
    }),
    [companyId, queryClient],
  );
}
